import type { TutorLanguage } from 'src/types/tutorLanguage';

import i18n from './config';

export async function syncTutorUiLanguage(language: TutorLanguage): Promise<void> {
  if (i18n.language !== language) {
    await i18n.changeLanguage(language);
  }

  if (typeof document !== 'undefined') {
    document.documentElement.lang = language;
  }
}
